/**
 * ErrorBoundary — Catches render errors in child components
 *
 * Displays a friendly error card with a "Try Again" button.
 * Uses `key={page}` in App.js to auto-reset when navigating away.
 * Navigation stays functional so users can switch pages after a crash.
 */
import React from 'react';
import theme from '../utils/theme';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="card" style={{ textAlign: 'center', padding: '2rem 1rem' }}>
          <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>Something went wrong</div>
          <p style={{ fontSize: '0.85rem', color: theme.textSecondary, marginBottom: '1rem' }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <button className="btn btn-primary" onClick={this.handleReset}>
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
